/**
 *  @desc 路由配置项
 *  @return { Object } constantRouterMap 无需认证即可访问的路由页面，router初始化时即注册
 *  @return { Object } asyncRouterMap 动态注册的路由，需要进行身份验证后或根据权限动态的注册
 *  @return.default { Object } router vue-router实例
 */

import Vue from 'vue';
import Router from 'vue-router';
import constantRouterMap from './constantRouterMap';
import asyncRouterMap from './asyncMap';

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
/**
 * @desc asyncMap/*.js 路由参数配置解释
 * 该目录存放需要经过验证后才能访问的路由页面，并且在AppMain.vue下router-view.body-container区域渲染
 *
 * 配置项： 默认值
 * name:'RouterName'              name为路由唯一标记，作为路由跳转或提供keep-alive功能识别，其name请保持和组件内name一直 (must set!!!).
 * meta : {
    title: 'title'                在菜单栏显示的名字
    savedPosition: { x: 0, y: 0 } 页签缓存的滚动条位置
    icon: 'svg-name'              当有icon时，会在菜单上显示，icon对应src/icons/svg/下.svg文件名
  }
  permission: true                白名单路由
 */

export {
    constantRouterMap,
    asyncRouterMap,
};

export default new Router({
    mode: 'hash', // pure browser, so required!
    linkActiveClass: 'is-active',
    // 原生只能控制html的滚动条
    scrollBehavior: (to, from) => {
        // 1. 进入非页签页面; 2.只是query或params变化(无实际页面切换);
        if (!to || !to.matched || !to.matched[1] || to.name === from.name) return;

        // 恢复滚动条位置
        Vue.nextTick(() => {
            // 滚动容器
            const scrollDom = document.querySelector('.body-container');
            if (!scrollDom) return;

            /**
             * 页签间切换, 恢复页签之前的滚动条位置
             * 页签内跳转, 重设页签滚动条位置
             */
            // 获取页签缓存的滚动条位置
            const tagSavedPosition = to.matched[1].meta.savedPosition || { x: 0, y: 0 };

            if (from && from.matched && from.matched[1] && from.matched[1].name === to.matched[1].name) {
                scrollDom.scrollLeft = 0;
                scrollDom.scrollTop = 0;
            } else {
                scrollDom.scrollLeft = tagSavedPosition.x;
                scrollDom.scrollTop = tagSavedPosition.y;
            }
        });
    },
    routes: constantRouterMap,
});
